import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ContactForm from './forms/ContactForm';
import MapWidget from '../widgets/MapWidget';

const ReactiveDiv = styled.div`
    .reactive {
        margin-top: 100px;
        margin-left: ${(props) => props.marginLeft};
        margin-bottom: 200px;
    }
`;

const Contact = (props) => {
    const { isSignedIn, themeColors, dashboardSidebarSize } = props;
    return (
        <ReactiveDiv
            themeColors={themeColors}
            marginLeft={isSignedIn ? dashboardSidebarSize : "0px"}
        >
            <div className="reactive">
                <div className="container">
                    <div className="row">
                        {/* CONTACT FORM */}
                        <div className="col-sm-6">
                            <div className="my-2">
                                <ContactForm />
                            </div>
                        </div>

                        {/* DETAILS */}
                        <div className="col-sm-6" style={{ backgroundColor: "transparent" }}>
                            <div className="my-2">
                                <div className="container">
                                    <div className="card">
                                        {/* <div style={{ height: "400px" }} className="text-right">
                                    <MapWidget />
                                </div>
                                <br></br> */}

                                        <div className="text-left card-body">
                                            <h4><b>AxiBuild</b></h4>
                                            <hr></hr>
                                            <p style={{ fontSize: "18px", fontWeight: "bold" }}>Offices:</p>
                                            <ul className="list-group">
                                                <li className="list-group-item">London, UK</li>
                                                <li className="list-group-item">Karachi, Pakistan</li>
                                            </ul>
                                            <hr></hr>
                                            <p style={{ fontSize: "18px", fontWeight: "bold" }}>Contact:</p>
                                            <ul className="list-group">
                                                <li className="list-group-item">sales@axibuild.com</li>
                                                <li className="list-group-item">info@axibuild.com</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ReactiveDiv>
    )
}

const mapStateToProps = (state) => {
    // console.log(state)
    return {
        isSignedIn: !state.firebase.auth.isEmpty,
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
    }
}

export default connect(mapStateToProps)(Contact);
